












import { computed, onMounted, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { pickStrict } from 'vtils'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '首页',
        }))

        onMounted(() => {
          setTimeout(() => {
            const style = window.getComputedStyle(this.blockRef.value!)
            this.safe.value = JSON.stringify(
              pickStrict(style, [
                'paddingTop',
                'paddingRight',
                'paddingBottom',
                'paddingLeft',
              ]),
              null,
              2,
            ).replaceAll('padding', 'safe')
          }, 1000)
        })
      }

      loading = computed(() => false)

      blockRef = ref<HTMLDivElement>()

      safe = ref<any>()
    },
)
